var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.keepAlivePath.includes(_vm.$route.path))?_c('router-view',{key:_vm.$route.fullPath,ref:"page"}):_vm._e()],1),(!_vm.keepAlivePath.includes(_vm.$route.path))?_c('router-view',{key:_vm.$route.fullPath,ref:"page"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }